import { useState } from 'react';
import Modal from '../../../shared/Modal';
import ExchangeCard from '../components/ExchangeCard';

const ExchangesPanel = ({ exchanges = [], className = '' }) => {
  const [open, setOpen] = useState(false);
  const sortedExchanges = [...exchanges].sort((a, b) => {
    const dateA = new Date(a.exchangeDate || 0).getTime();
    const dateB = new Date(b.exchangeDate || 0).getTime();
    return dateB - dateA;
  });
  const latestExchanges = sortedExchanges.slice(0, 3);
  const hasFullResume = sortedExchanges.length >= 3;

  return (
    <section className={`profile-exchanges-card ${hasFullResume ? 'profile-card-has-more' : ''} bg-white rounded-lg border border-gray-200 shadow-sm p-4 flex flex-col ${className}`}>
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-semibold text-gray-900">Canjes realizados</h2>
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="text-sm font-medium text-personalized hover:underline"
        >
          Ver Todos
        </button>
      </div>
      <div className="space-y-3">
        {sortedExchanges.length === 0 ? (
          <div className="rounded-lg border border-gray-200 bg-gray-50 px-4 py-8 text-center text-sm text-gray-500">
            No hay canjes realizados actualmente
          </div>
        ) : (
          latestExchanges.map((exchange) => (
            <ExchangeCard key={exchange.id} exchange={exchange} showDescription={false} />
          ))
        )}
      </div>
      <Modal
        isOpen={open}
        onClose={() => setOpen(false)}
        title="Canjes realizados"
      >
        <div className="p-4 mt-4 mb-4 sm:p-6 sm:mt-6 sm:mb-6 lg:p-8 lg:mt-8 lg:mb-8">
          <div className="bg-white shadow-md overflow-hidden h-full flex flex-col p-4 sm:p-5 lg:p-6">
            <div className="space-y-3">
              {sortedExchanges.map((exchange) => (
                <ExchangeCard key={exchange.id} exchange={exchange} />
              ))}
            </div>
          </div>
        </div>
      </Modal>
    </section>
  );
};

export default ExchangesPanel;
